import { Component } from "../base/Component";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { KeyModifiers, ModifierKeys } from "../keyhandling/KeyModifiers";

export interface ClickListener extends EventListener<ClickEvent> {
}

export class ClickEvent extends Event<Component> implements ModifierKeys {
    constructor(target: Component, domEvent?: Event | DomEvent) {
        super(target, domEvent);
    }

    public get altKey(): boolean {
        return this.domEvent.altKey;
    }

    public get ctrlKey(): boolean {
        return this.domEvent.ctrlKey;
    }

    public get shiftKey(): boolean {
        return this.domEvent.shiftKey;
    }

    public get domEvent(): MouseEvent {
        return super.domEvent as MouseEvent;
    }

    public hasModifiers(modifiers: ModifierKeys) {
        return KeyModifiers.hasModifiers(this, modifiers);
    }

    public static eventIsFromUserClick(event: Event | DomEvent) {
        if (event instanceof Event) {
            return (event?.domEvent instanceof PointerEvent ||
                    event?.domEvent?.type === "click"); // Can be click event in Firefox
        }
        return event != null && (event instanceof PointerEvent || event?.type === "click");
    }
}
